import { createButtonColorConfig } from '@99designs/emu';
import type { ButtonColorConfig } from '@99designs/emu';

export const getCtaColorConfig = (
    color: string,
    hover: string,
    active: string,
    textColor: string
): ButtonColorConfig => {
    return createButtonColorConfig({
        normal: {
            backgroundColor: color,
            backgroundColorHover: hover,
            backgroundColorActive: active,
            borderColor: color,
            borderColorHover: hover,
            borderColorActive: active,
            textColor: textColor,
            textColorHover: textColor,
            textColorActive: textColor,
        },
    });
};
